<template>
	<div class="sasa">
		<el-dialog title="楼层详情" :visible.sync="dialogFormVisible" width="70%" :close-on-click-modal="false">
			<!-- <div class="card-view search-card-view">
				<div class="search-form">
					<el-form ref="form" :inline="true" :model="searchform" label-width="100px">
						<el-form-item label="商品名称:">
							<el-input v-model="searchform.name" placeholder="请输入商品名称"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary">搜索</el-button>
							<el-button>重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div> -->
			<div class="card-view" style="margin-top: 10px">
				<div class="btn-group" style="margin-bottom: 10px">
					<el-button class="btn-black" @click="shua">
						刷新
					</el-button>
				</div>
				<el-table :data="datalist" border style="width: 100%" v-loading="loading">
                    <el-table-column
                        prop="company_name"
                        label="公司名称"
                       >
                    </el-table-column>
                    <el-table-column
                        prop="legal"
                        label="法人"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        label="电话"
                        width="180">
                    </el-table-column>
				</el-table>
				<div class="block">
                    <el-pagination background :page-size="page_size" :hide-on-single-page="true"
                                layout="prev, pager, next" 
                                @current-change="handleCurrentChange" :current-page="currentPage" :total="totalnum">
               </el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: '',
		data() {
			return {
				
				loading: false,
				
                dialogFormVisible:false,
                currentPage:1,
                page_size:8,
                datalist:[],
                totalnum:0,
                index:'',
                type:''
			}
		},
		methods: {
            shua(){
                // this.currentPage = 1
                this.company_list()
            },
            handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage;
            // console.log(this.currentPage)  //点击第几页
            // this.rightlist = [];
            this.company_list();
        },
            company_list() {
            this.loading = true
            this.$https.post(
                {
                    api: this.$api.api.demo.company_list,
                    type: "formData",
                },
                {
                    page:this.currentPage,
                    page_size:this.page_size,
                    hourse_number:this.type+'#',
                    hourse_floor:Number(this.index)+1
                },
                (response) => {
                    this.loading = false
                    this.datalist =  response.data
                    this.totalnum = response.count
                },
                (error) => {
                    console.log(error);
                }
            );
        },
			open(index,type){
                this.index = index
                if(type==10){
                    this.type = 0
                }else{
                    this.type = type
                }
                 
                this.dialogFormVisible = true
                this.company_list()
            }

		},
	}
</script>
<style lang="scss">
	.sasa{
        .el-dialog__body{
            padding: 20px ;
            padding-top: 0px;
        }
        .cell{
            text-align: center;
        }
    }


</style>
<style lang="scss" scoped>
	.title {
		// @include vb-title;
		margin-bottom: 10px;
	}
    .block{
        width: 100%;
        text-align: center;
        margin-top: 20px;
    }

</style>



// WEBPACK FOOTER //
// fooldetail.vue?49ff6cca